'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ModifyCell;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ModifyCell(props) {
  var _onClick = props.onClick,
      value = props.value,
      row = props.row;
  var buttonText = value ? 'Change' : 'Assign';
  return _react2["default"].createElement('button', {
    className: 'rainbow-import-records-flow_step-three-assign-button',
    onClick: function onClick() {
      return _onClick(row.databaseField);
    }
  }, buttonText);
}

ModifyCell.propTypes = {
  onClick: _propTypes2["default"].func,
  value: _propTypes2["default"].string,
  row: _propTypes2["default"].object.isRequired
};
ModifyCell.defaultProps = {
  onClick: function onClick() {},
  value: ''
};